import { render, staticRenderFns } from "./TitleDashDescription.vue?vue&type=template&id=3e159f22&scoped=true&"
import script from "./TitleDashDescription.vue?vue&type=script&lang=js&"
export * from "./TitleDashDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e159f22",
  null
  
)

export default component.exports